import { USER_PROFILE } from "@src/helpers/imagesConstants";
import { Card } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";

interface UserDetailsCardProps {
  name: string;
  id: string;
  referenceId: string | number;
  profile?: string;
}

const UserDetailsCard: React.FC<UserDetailsCardProps> = ({
  name,
  referenceId,
  id,
  profile,
}) => {
  const navigate = useNavigate();

  const onClick = () => {
    window.open(``);
  };

  return (
    <Card className="user-card" bordered={false}>
      <img
        src={profile || USER_PROFILE}
        className="user-profile-image"
        alt="User Profile"
      />
      <a className="user-card-info">
        <div className="user-card-name">{name}</div>
        <div className="user-card-id">{referenceId}</div>
      </a>
    </Card>
  );
};

export default UserDetailsCard;
